import { PageHeader } from "@shared/components/PageHeader";
import { Stepper } from "@shared/components/Stepper";
import { useToast } from "@shared/hooks/use-toast";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ApplicationDetailLanding } from "./applicationDetails/applicationDetailLanding";
import { ApplicationReviewLanding } from "./applicationReview/applicationReviewLanding";
import { GuestPortalTopnav } from "../../../Topnav";
import { AnnouncementBanner } from '../../../AnnouncementBanner';
import { useTranslation } from "react-i18next";

const NewConnectionLanding: React.FC = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleComplete = async (allStepData: any) => {
    toast({
      title: t("Application Submitted Successfully"),
    });

    // Navigate to consumer management or dashboard
    navigate("/cx/consumer-management/create");
  };

  const stepperSteps = React.useMemo(() => [
    {
      id: "application-details",
      title: t("Application Details & Documents"),
      component: <ApplicationDetailLanding />,
      slug: "application-details",
    },
    {
      id: "application-review",
      title: t("Application Review"),
      component: <ApplicationReviewLanding />,
      slug: "application-review",
    },
  ], [t]);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="shrink-0 sticky top-0 z-50">
        <GuestPortalTopnav />
        {/* Banner */}
        <AnnouncementBanner />
      </div>
      
      {/* Main Content Area */}
      <div className="flex-1 w-full">
        <div className="p-4">
          <div className="mb-6 flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate("/cx/consumer-onboarding/")}
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>

            <PageHeader
              title={t("New Connection")}
              subtitle={t("Create a new connection application")}
            />
          </div>

          <Stepper
            steps={stepperSteps}
            onComplete={handleComplete}
            allowStepClick={true}
          />
        </div>
      </div>
    </div>
  );
};

export default NewConnectionLanding;
